import { z } from 'zod';

export const deliveryAddressSchema = z.object({
  delivery_street_name: z.string().min(1),
  delivery_street_number: z.string().min(1),
  delivery_city: z.string().min(1),
  delivery_zip_code: z.string().min(1),
  delivery_country: z.string().nullable().optional(),
  delivery_lat: z.number().optional(),
  delivery_lng: z.number().optional(),
});

export type DeliveryAddressSchema = z.infer<typeof deliveryAddressSchema>;
